import type { Lead, WhatsappChat } from "../types.ts";
import { findLeadForChat } from "./Chat.helpers.ts";

export function resolveChatLeadForStager(
  chat: WhatsappChat,
  resolvedLead: Lead | null | undefined,
  leads: Lead[] = [],
): Lead | null {
  if (resolvedLead?.id !== undefined && resolvedLead.id !== null) return resolvedLead;
  return findLeadForChat(chat, leads);
}

export function shouldLinkChatToLead(
  chat: Pick<WhatsappChat, "chatJid" | "leadId">,
  lead: Pick<Lead, "id"> | null | undefined,
): boolean {
  const leadId = lead?.id !== undefined && lead?.id !== null ? String(lead.id) : "";
  if (!leadId) return false;
  return String(chat.leadId || "") !== leadId;
}

export function displayNameForLeadPayload(
  lead: Pick<Lead, "name" | "phone"> | null | undefined,
  display: string,
): string {
  const currentName = String(lead?.name || "").trim();
  const displayName = String(display || "").trim();
  if (!currentName) return displayName;
  if (isUsableHumanName(currentName)) return currentName;
  return isUsableHumanName(displayName) ? displayName : currentName;
}

function isUsableHumanName(value: string): boolean {
  const text = value.trim();
  if (!text) return false;
  const lowered = text.toLowerCase();
  if (lowered === "contato" || lowered === "sem nome") return false;
  if (!/\p{L}/u.test(text)) return false;
  return !/^[+\d\s().-]+$/.test(text);
}
